import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { PropertyOptionAndCount } from 'donor-elf-web/controllers/funds/fund/properties/property';
import type {
  BulkActionCustomListCustomPropertyOptionDelete,
  BulkActionResponseIncludesUpdatedFundProperties,
  BulkActionType,
} from 'donor-elf-web/models/bulk-action';
import ContactsCache, {
  type ContactCustomPropertyInfo,
  isGroupsContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  propertyInfo: ContactCustomPropertyInfo;
  optionAndCount: PropertyOptionAndCount;
  onDeleted: (option: string) => void;
  onClose: () => void;
}

export default class PropertiesOptionsDeleteModalComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  bulkActionType: BulkActionType = 'custom_property_list_option_delete';
  @tracked bulkActionCustom?: BulkActionCustomListCustomPropertyOptionDelete;

  @tracked deleting = false;
  @tracked deleteError = false;

  @action
  async delete() {
    this.bulkActionCustom = {
      property_label: this.args.propertyInfo.l,
      option: this.args.optionAndCount.option,
    };
    this.deleting = true;
  }

  @action
  async onCompleted(response: BulkActionResponseIncludesUpdatedFundProperties) {
    if (response.contact_ids.length < 250) {
      await this.contactsCache.reloadSpecificContacts(response.contact_ids);
    } else {
      await this.contactsCache.loadContacts({ forceLoad: true });
    }
    if (isGroupsContactCustomPropertyInfo(this.args.propertyInfo)) {
      // break the groups cache
      this.contactsCache.groupsCacheIndex += 1;
    } else {
      let customPropertyInfo = response.updated_fund_properties.find(
        (x) => x.l === this.args.propertyInfo.l,
      );
      this.contactsCache.updateCustomPropertyInfo(customPropertyInfo!);
    }

    this.args.onDeleted(this.args.optionAndCount.option);
  }

  @action
  onError() {
    this.deleteError = true;
  }
}
